"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useState } from "react";

export default function SavingsCalculator() {
  const [budget, setBudget] = useState("500000");

  const calculateSavings = (amount: number) => {
    const minSavings = amount * 0.025;
    const maxSavings = amount * 0.03;
    return { min: minSavings, max: maxSavings };
  };

  const savings = calculateSavings(Number(budget) || 0);

  const formatCurrency = (value: string) => {
    const number = Number.parseFloat(value.replace(/[^\d.]/g, ""));
    return Number.isNaN(number)
      ? ""
      : number.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
  };

  const handleBudgetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^\d]/g, "");
    setBudget(value);
  };

  return (
    <Card className="w-full max-w-md mx-auto my-8 bg-gradient-to-br from-plaster to-plaster-lighter text-smokeyBlack shadow-xl">
      <CardHeader className=" text-iceWhite rounded-t-lg">
        <CardTitle className="text-2xl font-bold text-center font-satoshi text-black">
          Savings Calculator
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <div className="space-y-6">
          <div>
            <Label
              htmlFor="budget"
              className="text-smokeyBlack font-semibold mb-2 block"
            >
              Enter your home budget:
            </Label>
            <Input
              id="budget"
              type="text"
              placeholder="e.g., $400,000"
              value={formatCurrency(budget)}
              onChange={handleBudgetChange}
              className="mt-1 bg-iceWhite border-darkGray text-smokeyBlack placeholder-lightGray"
            />
          </div>
          <div className="text-center bg-chalk rounded-lg p-4">
            <p className="text-lg font-semibold text-smokeyBlack mb-2">
              Potential Savings:
            </p>
            <p className="text-4xl font-black text-plaster">
              {formatCurrency(savings.min.toString())} -{" "}
              {formatCurrency(savings.max.toString())}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
